export default "__VITE_ASSET__CvcLcaL___"